import React from "react";
import { Box } from "@mui/material";
import { makeStyles } from "tss-react/mui";
import { ChipWithTooltip } from "./Chips.js";
import { ChipVariant, ChipType } from "./types.js";
const useStyles = makeStyles()((theme) => ({
  visibleElementContainer: {
    marginRight: theme.spacing(0.5)
  },
  dropdownContent: {
    display: "grid",
    gridGap: theme.spacing(1),
    justifyItems: "baseline"
  }
}));
function ListWithChipTooltip({
  visibleElement,
  hiddenElements,
  chipType = ChipType.Status,
  chipVariant = ChipVariant.Grey
}) {
  const { classes } = useStyles();
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(Box, { className: classes.visibleElementContainer }, visibleElement), hiddenElements?.length ? /* @__PURE__ */ React.createElement(
    ChipWithTooltip,
    {
      chipType,
      chipVariant,
      label: `+${hiddenElements?.length}`,
      fillWidth: false,
      title: /* @__PURE__ */ React.createElement(Box, { className: classes.dropdownContent }, hiddenElements),
      hideTooltip: false
    }
  ) : null);
}
export {
  ListWithChipTooltip
};
//# sourceMappingURL=ListWithChipTooltip.js.map
